import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-contact-support',
  templateUrl: './profile-contact-support.component.html',
  styleUrls: ['./profile-contact-support.component.scss'],
})
export class ProfileContactSupportComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
